module.exports = __webpack_public_path__ + "img/icons.be47d36c.svg";